<template>
  <div id="app">
    <hero></hero>
    <use-section></use-section>
    <swiper></swiper>
    <animation></animation>
    <features></features>
    <benefits></benefits>
    <contact></contact>
    <footer class="footer">
      <img :src="require('@/assets/img/caredo-logo-small.svg')" class="footer__logo">
      <p class="footer__copyright">
        Copyright 2020. Wszelkie prawa zastrzeżone.
      </p>
    </footer>
  </div>
</template>

<script>
const Hero = () => import('@/components/Hero');
const UseSection = () => import('@/components/Use');
const Features = () => import('@/components/Features');
const Benefits = () => import('@/components/Benefits');
const Contact = () => import('@/components/Contact');
const Swiper = () => import('@/components/Swiper');
const Animation = () => import('@/components/Animation');

export default {
  name: 'Caredo',
  components: {
    Hero,
    UseSection,
    Features,
    Benefits,
    Contact,
    Swiper,
    Animation,
  },
};
</script>

<style lang="scss">
#app {
  background-color: $bg-primary;
  color: $primary;
  font-family: $default-font;
  font-size: 1rem;
  margin: 0 auto;
  max-width: 1920px;
}

.row {
  align-items: center;
  background-color: $bg-secondary;
  color: $primary;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  opacity: 0;
  padding: 110px 0;
  text-align: center;
  transform: translateY(200px);
  transition: 1s;

  &--inverted {
    background-color: $bg-primary;
    color: $inverted;
  }

  &--split {
    padding: 0;

    .row__title {
      text-align: left;
    }
  }

  &--slidup {
    opacity: 1;
    transform: none;
  }
}

.row__header {
  width: 100%;
}

.row__title {
  font-family: $header-font;
  font-size: 2.625em;
  margin: 0 0 10px;
  padding: 0 40px;

  &--small {
    font-size: 2.25em;
  }

  &--nopad {
    padding: 0;
  }
}

.row__subtitle {
  font-size: 1.625em;
  margin: 0 40px;
}

.row__highlight {
  color: $highlight;
}

.row__image,
.row__content {
  max-height: 960px;
  width: 50%;
}

.row__image {
  height: 50vw;
  min-height: 300px;
  position: relative;

  @media screen and (max-width: 1000px) {
    height: 40vw;
    width: 40%;
  }

  @media screen and (max-width: 900px) {
    height: 50vw;
    object-fit: cover;
    width: 100%;
  }
}

.row__content {
  margin: 0 auto;
  max-width: 600px;
  padding: 0 20px;

  @media screen and (max-width: 1000px) {
    width: 60%;
  }

  @media screen and (max-width: 900px) {
    padding: 40px;
    width: 100%;
  }

  @media screen and (max-width: 700px) {
    max-width: none;
  }
}

.footer {
  align-items: center;
  background-color: $bg-secondary;
  color: $primary;
  display: flex;
  justify-content: space-between;
  padding: 40px 7.3vw;

  @media screen and (min-width: 1920px) {
    padding: 40px 140px;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;

    .footer__logo {
      margin-bottom: 20px;
    }
  }
}
</style>
